import React, { useState } from 'react';
import { authService } from '../services/supabase';

const PasswordResetForm = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Inserisci un indirizzo email');
      return;
    }
    
    setLoading(true);
    setError('');
    setMessage('');
    
    try {
      await authService.resetPassword(email);
      setMessage('Ti abbiamo inviato un link per reimpostare la password. Controlla la tua email.');
    } catch (err) {
      setError('Errore durante l\'invio dell\'email di reset: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Reimposta la password
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Inserisci la tua email per ricevere un link di reset
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">Indirizzo Email</label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Indirizzo Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          
          {error && (
            <div className="rounded-md bg-red-50 p-4 text-center">
              <div className="text-sm text-red-700">{error}</div>
            </div>
          )}
          
          {message && (
            <div className="rounded-md bg-green-50 p-4 text-center">
              <div className="text-sm text-green-700">{message}</div>
            </div>
          )}
          
          <div className="flex flex-col space-y-4">
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              {loading ? 'Invio in corso...' : 'Invia link di reset'}
            </button>
            
            <button
              type="button"
              onClick={onBack}
              className="w-full py-2 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Torna al login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetForm;